export default __webpack_public_path__ + "locales/hy-AM/ChangeUserTypeDialog.json?hash=fb7c0a1df6dc978726be4557df696da2";